import React from 'react'
import { withStyles } from '@material-ui/core'
import NavBar from '../components/NavBar'
import Feed from '../components/Feed'
import Layout from '../components/Layout'

import { graphql } from 'gatsby'

const styles = themes => ({
  root: {
    flexGrow: 1,
    padding: '24px',
    overflow: 'hidden',
  },
})

const Category = props => {
  const { data, classes } = props

  const posts = data.posts ? data.posts.edges : []
  return (
    <Layout>
      <div className={classes.root}>
        <NavBar />
        <Feed posts={posts} />
      </div>
    </Layout>
  )
}

export const query = graphql`
  query PostsByCategory($category: String!) {
    posts: allContentfulBlogPost(
      sort: { order: DESC, fields: postDate }
      filter: { category: { url: { eq: $category } } }
    ) {
      edges {
        node {
          title
          titleUrl
          headerImage {
            file {
              url
            }
          }
          category {
            displayText
            url
          }
          postDate
          bodyText {
            bodyText
          }
        }
      }
    }
  }
`
export default withStyles(styles)(Category)
